var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 9,
    viewBox: "0 0 37 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_223121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4995 0L0.4375 8.988H5.2995L5.9025 7.555H7.2805L7.8835 8.988H13.2355V7.895L13.7125 8.988H16.4805L16.9575 7.872V8.988H28.0885L29.4425 7.593L30.7095 8.988L36.4265 9L32.3525 4.52L36.4265 0H30.7985L29.4805 1.37L28.2535 0H16.1445L15.1045 2.32L14.0405 0H9.1875V1.057L8.6485 0H4.4995ZM5.4395 1.276H7.8105L10.5045 7.372V1.276H13.1005L15.1815 5.646L17.0995 1.276H19.6825V7.726H18.1105L18.0985 2.672L15.8065 7.726H14.4005L12.0955 2.672V7.726H8.8615L8.2485 6.28H4.9365L4.3245 7.725H2.5915L5.4395 1.276ZM21.1215 1.276H27.5135L29.4685 3.388L31.4865 1.276H33.4415L30.4705 4.518L33.4415 7.722H31.3975L29.4425 5.586L27.4145 7.722H21.1215V1.276ZM6.5925 2.368L5.5015 4.944H7.6825L6.5925 2.368ZM22.6995 2.612V3.789H26.1865V5.101H22.6995V6.387H26.6105L28.4285 4.494L26.6875 2.611L22.6995 2.612Z",
    fill: "#2478BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_223121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAmex);
export default __webpack_public_path__ + "static/media/logo_amex.569fce452f43d6c07f7cc0bed26ef136.svg";
export { ForwardRef as ReactComponent };